import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Customers_Numbers_Object} state
 *  @property {object} model
 *  @property {Customers_Numbers_Properties} model.properties
 *  @property {Customers_Numbers_Is} model.is
 *  @property {Customers_Numbers_Has} model.has
 */
export default class CustomerPhone extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		phone: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Customers_Numbers._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.phone;

		if (!data) return;

		let newState = {
			loading: false,
			loaded: true,
		};

		if (this._ismounted) {
			this.model.properties.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.has.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.model.is.forEach((item, key) => {
				if (item && typeof data[key] !== 'undefined') {
					newState[key] = data[key];
				}
			});

			this.setState(newState, () => this.loadSelfAfter(data))
		}

		this.loadSelfAfterAlways();
	};

	form = () => {
		/** @type {Customers_Numbers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Numbers_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">Phone</h4>
					<div className="form-group">
						<Framework.Elements.PhoneNumber
							property={properties.number}
							value={object.number}
							error={object.number_error}
							update={this.handleTextFieldPropertyUpdate}
							id={"phone_number"}
						/>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
